import { Button, Drawer, Hairline, Label, Message, Select } from "@components";
import React from "react";
import Toggle2 from "shared/components/Toggle2";
import styles from "../../../../styles/integrations.module.scss";
import { EnvironmentStorage } from "shared/tools/EnvironmentStorage";
import { EnvironmentsAPI } from "providers/EnvironmentsAPI";

export default class CustomerPermissionsDrawer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      customer_permissions: {
        PAYMENT_ONLINE: false,
      },
    };
  }

  async componentDidMount() {
    const environment_id = await EnvironmentStorage.getEnvironmentHoldingId();
    const customer_permissions = await EnvironmentsAPI.getConfigurationsByAlias(
      environment_id,
      "customer_permissions",
      []
    );
    this.setState({ customer_permissions });
  }

  async onToggleValidation(type) {
    const { validations } = this.state;
    if (validations.includes(type)) {
      this.setState({
        validations: validations.filter((validation) => validation !== type),
      });
    } else {
      this.setState({
        validations: [...validations, type],
      });
    }
  }

  async loading(asyncAction) {
    this.setState({ loading: true });
    await asyncAction();
    this.setState({ loading: false });
  }

  async save() {
    await this.loading(async () => {
      const { customer_permissions } = this.state;
      const holdingId = await EnvironmentStorage.getEnvironmentHoldingId();
      const payload = { customer_permissions };
      const permissionsResponse =
        await EnvironmentsAPI.putConfigurationsByAlias(
          holdingId,
          "customer_permissions",
          payload
        );

      if (permissionsResponse.getErrors([]).length > 0) {
        alert({ text: permissionsResponse.getErrors()[0], buttonText: "Ok" });
      } else {
        alert({
          text: "Configuração alterada com sucesso!",
          buttonText: "Ok",
        });
      }
    });

    return true;
  }

  render() {
    const { visible, onClose } = this.props;
    const { loading, customer_permissions } = this.state;

    return (
      <Drawer
        visible={visible}
        onClose={onClose}
        closeInFade
        title="Validação por pedido real"
      >
        <Message
          type="warning"
          className="mb-20"
          text="Ao ativar esta chave, os clientes precisarão ter ao menos um pedido finalizado com pagamento no PIX, ou pagamento na entrega, para realizar pedidos com pagamento online."
        />
        <div className={styles.box}>
          <Toggle2
            id="payment-online"
            title="Ativar validação por pedido real"
            checked={customer_permissions.PAYMENT_ONLINE}
            onChange={() => {
              this.setState({
                customer_permissions: {
                  ...customer_permissions,
                  PAYMENT_ONLINE: !customer_permissions.PAYMENT_ONLINE,
                },
              });
            }}
          />
        </div>
        <div className={styles.footer}>
          <Button
            className="w-100"
            design="primary"
            disabled={loading}
            loading={loading}
            onClick={() => this.save()}
          >
            Salvar alterações
          </Button>
        </div>
      </Drawer>
    );
  }
}
